export class Coverage {
    constructor({
        id = null,
        name = null,
        price = 0,
        monthlyPrice = 0,
        code = null,
    } = {}) {
        this.id = id;
        this.name = name;
        this.price = price;
        this.monthlyPrice = monthlyPrice;
        this.code = code || name;
    }
}
